import React from 'react'
import buildImageUrl from '../../../lib/media-url-maker'
import htmlStripper from '../../../lib/html-stripper'

const Image = (props) => {
  const alt = props.alt ? htmlStripper(props.alt) : null

  return (
    <img
      src={buildImageUrl({ ...props })}
      alt={alt}
      title={alt}
      width={props.imgWidth}
    />
  )
}

export default Image
